import { XIcon } from "@heroicons/react/solid";
import { openDB } from "idb";
import React, { useEffect, useState, useContext } from "react";
import { v4 as uuid } from "uuid";
import Context from "../context/context";
export default function NewSection({
  close,
  id,
  type,
  value,
  order,
  setNewSectionCreated,
}) {
  const context = useContext(Context);
  const { updateUnSync } = context;
  const [sectionName, setSectionName] = useState(type === "New" ? "" : value);
  useEffect(() => {
    if (value) {
      setSectionName(value);
    }
  }, [value]);

  // Adding new section to outlet.section_details collection in IndexedDB
  const handleAddNewSection = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const objectStore = await db
      .transaction("outlet", "readwrite")
      .objectStore("outlet");
    let outlet = await objectStore.get(localStorage.getItem("outlet_uuid"));
    const id = uuid();
    const sectionArray = outlet.section_details;
    const sectionDetails = {
      IDENTIFIER: "section-new:" + id,
      RECON_TIME: Date.now(),
      section_uuid: id,
      section_name: sectionName,
      section_sort_order: `${
        parseInt(sectionArray[sectionArray.length - 1]?.section_sort_order) +
          1 || 1
      }`,
    };
    const data = {
      ...outlet,
      section_details: [
        ...outlet.section_details,
        Object.keys(sectionDetails)
          .filter((key) => key !== "RECON_TIME")
          .reduce((obj, key) => {
            obj[key] = sectionDetails[key];
            return obj;
          }, {}),
      ],
    };
    await objectStore.put(data);
    handleSectionUnsyncedFile(sectionDetails);
    setNewSectionCreated(id);
    close();
  };

  // Editing section in outlet.section_details collection in IndexedDB
  const handleEditSection = async (sectionName) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const objectStore = await db
      .transaction("outlet", "readwrite")
      .objectStore("outlet");
    const outlet = await objectStore.get(localStorage.getItem("outlet_uuid"));
    const allSections = await outlet.section_details;
    let notUpdateSections = allSections.filter(
      (section) => section.section_uuid !== id
    );
    const sectionDetails = {
      section_uuid: id,
      section_name: sectionName,
      section_sort_order: order,
      RECON_TIME: Date.now(),
      IDENTIFIER: "section-edit:" + id,
    };
    const data = {
      ...outlet,
      section_details: [...notUpdateSections, sectionDetails],
    };
    await objectStore.put(data);
    handleSectionUnsyncedFile(sectionDetails);
    setNewSectionCreated(uuid());
    close();
  };
  // Editing existing section in unsynced_files collection in IndexedDB
  const handleSectionUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    await tx.put(data);
    handleReconciliation(data);
  };

  // Adding section in reconciliation collection in IndexedDB
  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const sectionsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "section"
    );
    if (sectionsJsonExists) {
      const sections = sectionsJsonExists?.details?.filter(
        (section) => section.section_uuid !== data.section_uuid
      );
      const editData = {
        ...sectionsJsonExists,
        details: [
          ...sections,
          {
            section_uuid: data.section_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "section",
        details: [
          {
            section_uuid: data.section_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }

    updateUnSync();
  };

  return (
    <div
      className='newCategory'
      onKeyDown={(e) =>
        e.key === "Enter" && sectionName !== ""
          ? type === "New"
            ? handleAddNewSection()
            : handleEditSection()
          : 
              document.getElementById("sectionName").focus()
             
            
      }>
      <div className='newCatContainer'>
        <div className='newCatContainer_header'>
          <h2>Section</h2>
          <XIcon className='closeicon' onClick={close} />
        </div>
        <div className='newCatContainer2'>
          <div className='cat-inp'>
            <label htmlFor='sectionName'>Section Name</label>
            <input
              value={sectionName}
              onChange={(e) => setSectionName(e.target.value)}
              maxLength={15}
              type='text'
              id='sectionName'
              onFocus={function (e) {
                var val = e.target.value;
                e.target.value = "";
                e.target.value = val;
              }}
            />
          </div>
          {type === "New" ? (
            <button
              onClick={sectionName !== "" ? () => handleAddNewSection() : ""}>
              Save
            </button>
          ) : (
            <button
              onClick={
                sectionName !== "" ? () => handleEditSection(sectionName) : ""
              }>
              Update
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
